import React from 'react';
import { StripeProvider as RNStripeProvider } from '@stripe/stripe-react-native';
import { usePaymentsContext } from './PaymentsProvider';
import { ERROR_MESSAGES } from '../../shared/constants';
import { View, Text, StyleSheet } from 'react-native';

interface StripeProviderProps {
  children: React.ReactElement | React.ReactElement[];
  merchantIdentifier?: string;
  urlScheme?: string;
  publishableKey?: string;
  setReturnUrlSchemeOnAndroid?: boolean;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({
  children,
  merchantIdentifier,
  urlScheme,
  publishableKey,
  setReturnUrlSchemeOnAndroid = false,
}) => {
  const { config, initialized } = usePaymentsContext();

  if (!initialized) {
    if (config?.environment === 'development') {
      return (
        <View style={styles.errorContainer}>
          <Text style={styles.errorTitle}>Payments Provider Error</Text>
          <Text style={styles.errorMessage}>
            {ERROR_MESSAGES.PROVIDER_NOT_CONFIGURED}
          </Text>
          <Text style={styles.errorSubtext}>
            Please check your PaymentsProvider configuration.
          </Text>
        </View>
      );
    }
    return null;
  }

  const finalPublishableKey = publishableKey || config?.publishableKey;

  if (!finalPublishableKey) {
    return null;
  }

  return (
    <RNStripeProvider
      publishableKey={finalPublishableKey}
      merchantIdentifier={merchantIdentifier}
      urlScheme={urlScheme}
      setReturnUrlSchemeOnAndroid={setReturnUrlSchemeOnAndroid}
    >
      {children}
    </RNStripeProvider>
  );
};

const styles = StyleSheet.create({
  errorContainer: {
    padding: 20,
    backgroundColor: '#fee',
    borderColor: '#fcc',
    borderWidth: 1,
    borderRadius: 4,
    margin: 10,
  },
  errorTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#c53030',
    marginBottom: 8,
  },
  errorMessage: {
    fontSize: 14,
    color: '#c53030',
    marginBottom: 4,
  },
  errorSubtext: {
    fontSize: 12,
    color: '#a0a0a0',
  },
});

export default StripeProvider;
